export default __webpack_public_path__ + "static/media/warning--flaggers-in-road--g2.4b786672.png";